/**
 * Helper function to create a display object for an email string
 * @param {string} email - Email address
 * @returns {Object} - Email object for AutoComplete display
 */
export const createEmailObject = (email) => ({
  username: email,
  email: email,
  _isNewEmail: true,
});

// Helper function to get user name by ID
export const getUserName = (userId, users = []) => {
  if (!userId) return 'Not assigned';
  const user = users.find((u) => u.id === userId);
  return user ? user.username : 'Unknown User';
};

// Helper function to get user object by ID
// Also handles email strings for invited users
export const getUserById = (userId, users = []) => {
  // If it's a string (email), create an email object
  if (typeof userId === 'string') {
    return createEmailObject(userId);
  }
  // Otherwise, assume it's a numeric ID
  return users.find((u) => u.id === userId) || null;
};

// Helper function to get user names for multiple IDs
export const getUserNames = (userIds, users = []) => {
  if (!Array.isArray(userIds) || userIds.length === 0) return [];
  return userIds.map((id) => getUserName(id, users));
};

// Helper function to map user IDs to user objects
// Also handles email strings for invited users
export const mapIdsToUsers = (userIds, users = []) => {
  if (!Array.isArray(userIds)) return [];
  return userIds.map((id) => getUserById(id, users)).filter(Boolean);
};
